export const IND_COLOURS = {
  GREEN: 'green',
  ORANGE: 'orange',
  RED: 'red'
}

export const AWS_PIPELINE_STATUS = {
  PROVISIONED: 'PROVISIONED',
  PROVISIONING: 'PROVISIONING',
  UNPROVISIONED: 'UNPROVISIONED',
  FAILED: 'FAILED',
  FAILED_TO_FETCH: 'FAILED TO FETCH STATUS',
  DELETING: 'DELETING'
}

export const AWS_CHANNEL_STATUS = {
  RUNNING: 'RUNNING',
  CREATED: 'CREATED'
}

export const AWS_FLOW_STATUS = {
  ACTIVE: 'ACTIVE',
  RUNNING: 'RUNNING',
  STARTING: 'STARTING',
  UPDATING: 'UPDATING',
  CREATED: 'CREATED'
}
